import React, {useEffect, useState} from 'react';
import './style.scss';

export const GameStartCountdown = ({seconds, onStop}) => {
  const [time, setTime] = useState(seconds);

  useEffect(() => {
    let timer = setInterval(() => {
      setTime((time) => {
        if (time === 1) {
          clearInterval(timer);
          return 0;
        } else return time - 1;
      });
    }, 1000);
  }, []);

  useEffect(() => {
    if (time === 0) {
      onStop(true);
    }
  }, [time]);

  if (time > 0) {
    return <div className="app-game-start-countdown">{time}</div>
  }
}
